/* eslint-disable indent */
/* ====================================================================
   IMPORTS
   ==================================================================== */

/**
 * Dependency imports
 */

import createBehaviour from '../helpers/_createBehaviour';

/**
 * Behaviour imports
 */

import getCurrentMediaQuery from '../helpers/_getCurrentMediaQuery';

/* ====================================================================
   BEHAVIOURS —> FADE ACCORDION
   ==================================================================== */

const filterAccordion = createBehaviour(
  /**
   * Register a name for the behaviour
   */

  'filterAccordion',
  {
    /**
     * All behaviour functions should be defined here and will be
     * accessible through 'this'
     *
     * Event listeners, intervals etc. will need to be registered
     * using the below lifecycle events
     */

    logInit() {
      console.log(this.name + ': Initialised');
    },
    logEnabled() {
      console.log(this.name + ': Enabled');
    },
    logDestroyed() {
      console.log(this.name + ': Destroyed');
    },
    toggleDrawer() {
      console.log('toggle');
      if (this.direction == 'open') {
        this.drawer.classList.add('is-open');
        this.indicator.innerText = '-';
        this.direction = 'closed';
      } else {
        this.drawer.classList.remove('is-open');
        this.indicator.innerText = '+';
        this.direction = 'open';
      }
    }
  },
  {
    init() {
      /**
       * The behaviour has been initialised; event listeners,
       * variables etc. should be registered here
       *
       * All functions, variables etc. are accessible through `this`
       */

      /**
       * Expose the behaviour object for debugging
       */
      // console.log(this.name + ':', this);

      this.btn = this.getChild('btn');
      this.drawer = this.getChild('drawer');
      this.indicator = this.getChild('indicator');
      this.direction = 'open';

      this.btn.addEventListener('click', this.toggleDrawer);
    }
  }
);

export default filterAccordion;
